__turbopack_context__.v({
  "dialog": "hQe5Ka_dialog",
});
